import type {HotelDetails as HotelDetailsFromS3} from '@/api/hoteldetails/client';
import type {HotelDetails, ImageItem} from '@/api/hoteldetails/types';

import {queryOptions} from '@tanstack/react-query';

export const createHotelDetailsQueryOptions = (hotelId: string) =>
  queryOptions({
    queryKey: ['hotelDetails', {hotelId}],
    queryFn: (): Promise<HotelDetails> => {
      return fetch(
        `${import.meta.env.VITE_SERVICE_HOTEL_DETAILS_URL}/details/${hotelId}.json`
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }

          throw new Error('Failed to fetch hotel details');
        })
        .then((data: HotelDetailsFromS3) => {
          return {
            ...data,
            name: data.name ?? '',
            badgeText: data.score_description,
            categoryType: data.categoryType ?? 'unverified',
            isSustainable: data.isSustainable ?? false,
            address: {
              country: data.address?.country,
              countryCode: data.address?.countryCode,
              region: data.address?.region ?? data.region,
              city: data.address?.city ?? data.city,
              zip: data.address?.zip,
              street: data.address?.street,
              streetNumber: data.address?.streetNumber,
            },
            descriptionCurated: data.descriptionCurated ?? [],
            attributes: (data.attributes ?? []).map((group) => ({
              ...group,
              attributes: group.attributes.map((attribute) => ({
                ...attribute,
                value: attribute.value ?? '',
              })),
            })),
            images: (
              data.images?.filter(
                (
                  image
                ): image is {
                  type: string;
                  large: {url: string};
                  small: {url: string};
                } =>
                  Boolean(
                    image.type &&
                      typeof image.large?.url === 'string' &&
                      typeof image.small?.url === 'string'
                  )
              ) ?? []
            ).map((item) => ({
              ...item,
              categoryCodes: [],
              tourOperatorAndSeasons: [],
            })) satisfies Array<ImageItem>,
          };
        });
    },
  });
